import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { DprProgressReport } from '@report/models';
import { StaticMessage } from '@shared/enums';
import { DprProgress } from '@shared/models/dpr';
import {
  Progress,
  ProgressTerminology,
  SubprojectConfiguration,
} from '@shared/models/project-setup';

@Component({
  selector: 'app-report-progress',
  templateUrl: './report-progress.component.html',
  styleUrls: ['./report-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportProgressComponent implements OnInit {
  @Input({ required: true }) progress: Progress;
  @Input({ required: true }) dprProgress: DprProgress;
  @Input({ required: true }) subprojectConfiguration: SubprojectConfiguration;

  progressReport: DprProgressReport[] = [];

  StaticMessage = StaticMessage;

  get progressTerminology(): ProgressTerminology {
    return this.progress.progressTerminology;
  }

  ngOnInit(): void {
    this.progress?.progressItems.forEach((progress) => {
      const detail = (this.dprProgress.dprProgressDetails || []).find(
        (x) => x.progressId === progress.id
      );

      this.progressReport.push({
        name: progress.name,
        targetTotal: progress.initialValue?.toFixed(2),
        clearedToday: detail.clearedToday?.toFixed(2) ?? '-',
        progressStockDetails: detail.progressStockDetails ?? {},
        comment: detail.comment ?? '-',
      });
    });
  }
}
